module.exports = __webpack_public_path__ + "img/trash-icon.a5d6e851.svg";